<template>
  <div class="page">
    <div class="ctrl">
      <router-link :to="'/tuanpai/goods/create?auc_id=' + auc_id">
        <a-button type="primary">添加拍品</a-button>
      </router-link>
    </div>

    <a-table
      class="sec"
      size="small"
      :rowKey="(record) => record.id"
      bordered
      :columns="columns"
      :data-source="list"
      :pagination="false"
    >
      <template slot="thumb" slot-scope="text, record">
        <img style="height: 40px" :src="record.thumb" alt="" />
      </template>
      <template slot="status" slot-scope="text, record">
        <a-tag v-if="record.status == 1" color="green">正常</a-tag>
        <a-tag v-else color="red">已删除</a-tag>
      </template>

      <template slot="bid" slot-scope="text, record">
        <router-link  :to="'/tuanpai/goods/bidList?goods_id=' + record.id"
          >出价记录</router-link
        >
      </template>

      <template slot="action" slot-scope="text, record">
        <router-link :to="'/tuanpai/goods/info?id=' + record.id"
          >详情</router-link
        >
        <a-divider type="vertical" />
        <router-link :to="'/tuanpai/goods/update?id=' + record.id"
          >编辑</router-link
        >
        <a-divider type="vertical" />
        <a-popconfirm
          :title="record.status == 1 ? '确定要删除吗？' : '确定要恢复吗？'"
          ok-text="确定"
          cancel-text="取消"
          @confirm="updateStatus(record.id, (record.status + 1) % 2)"
        >
          <a href="javascript:;">{{ record.status == 1 ? "删除" : "恢复" }}</a>
        </a-popconfirm>
      </template>
    </a-table>
  </div>
</template>

<style lang='scss' scoped>
</style>

<script>
const columns = [
  {
    title: "#",
    dataIndex: "id",
  },
  {
    title: "封面图片",
    scopedSlots: {
      customRender: "thumb",
    },
  },
  {
    title: "名称",
    dataIndex: "name",
  },
  {
    title: "编号",
    dataIndex: "sn",
  },
  {
    title: "赢家限量",
    dataIndex: "winner_q",
  },
  {
    title: "起拍价",
    dataIndex: "price",
  },
  
  {
    title: "出价记录",
    scopedSlots: {
      customRender: "bid",
    },
  },
  {
    title: "状态",
    scopedSlots: {
      customRender: "status",
    },
  },
  {
    title: "操作",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export default {
  data() {
    return {
      columns,
      auc_id: null,
      list: [],
    };
  },
  created() {
    this.auc_id = this.$route.query.auc_id;
    this.getList();
  },
  methods: {
    async getList() {
      const r = await this.$axios.get("/tuanpai/goods/getList", {
        params: {
          auc_id: this.auc_id,
        },
      });

      if (r.status != 1) return;

      this.list = r.list;
    },

    async updateStatus(id, status) {
      const r = await this.$axios.post("/tuanpai/goods/updateStatus", {
        id,
        status,
      });

      if (r.status == 1) this.getList();
    },

    async exportOrder() {
      const r = await this.$axios.get("/tuanpai/goods/exportOrder?auction_id=" + this.auc_id);

      if (r.status == 1) window.open(r.path)
    },
  },
};
</script>